import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const sortbyHeader = {
  display_name: 'name',
  name: 'owner_name',
  email: 'email',
};
const GetAllRecords = {
  name: 'distributors',
  state: {
    data: [],
    allRecords:[],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Company Name',
      'Manager Name',
      'Email',
      'Displays',
      'Industry',
      '# Advertisers',
      '# Active Ads',
      'Account Manager',
    ],

    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
        allRecords:[],
      };
    },

    getReceived(state, payload) {
      const arr = [];
      payload?.data?.forEach((element) => {
        arr.push({
          id: element?.id,
          name: element?.name ? element.name : "-",
          owner_name: element?.owner_name ? element?.owner_name : 'No owner',
          email: element?.email ?element?.email :"-",
          displays: element?.displays,
          industry:element?.industry!==null ? element.industry : 'No Industry',
          advertisers: element?.advertisers ? element?.advertisers : "0",
          ads: element?.ads ? element?.ads : "0",
          active: element?.active,
          isRestricted: element?.isInvoicesRestricted,
          account_manager_id: element?.account_manager_id ?? null,
          account_manager_name: element?.account_manager_name ?? null,
          account_manager_email: element?.account_manager_email ?? null,
          account_manager: {
            type: 'account_manager',
            assigned: Boolean(element?.account_manager_id),
            name: element?.account_manager_name || null,
            email: element?.account_manager_email || null,
          },
        });
      });
      const allRecords = [];
      payload?.allRecords?.forEach((element) => {
        allRecords.push({
          id: element?.id,
          name: element?.name,
          owner_name: element?.owner_name ? element?.owner_name : 'No owner',
          email: element?.email,
          displays: element?.displays,
          industry:element?.industry!==null ? element.industry : 'No Industry',
          advertisers: element?.advertisers,
          ads: element?.ads,
          isRestricted: element?.isInvoicesRestricted,
        });
      });
      return {
        ...state,
        data: arr,
        allRecords:allRecords,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size, search, sorted_by, sort }) {
      try {
        this.getRequested();

        let url = `savvy/organization/get-dsos/?page=${page}&size=${size}`;
        if (search) {
          url = url + `&search="${search}"`;
        }
        if (sorted_by) {
          url =
            url +
            `&sorted_by=${
              sortbyHeader[sorted_by] ? sortbyHeader[sorted_by] : 'id'
            }`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data?.activeOrganizations,
          allRecords:response.data.data?.allData,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAllRecords;
